module.exports = __webpack_public_path__ + "media/site/images/technologies/capistrano-icon-1525221b4def3d122477f74d0fbea05b.svg";